import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "modal-footer" }
const _hoisted_4 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade show opacity-100 d-flex align-items-center justify-content-center",
    style: {"background-color":"rgba(0, 0, 0, 0.5)"},
    onClick: _cache[1] || (_cache[1] = (...args) => ($options.handle_close && $options.handle_close(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString($props.message), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.buttons, (label, key, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: key,
              class: _normalizeClass(["btn", $options.get_button_class(key, index)]),
              type: "button",
              onClick: $event => ($options.handle_close(key))
            }, _toDisplayString(label), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}